import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import { DownloadOutlined } from "@ant-design/icons";
import "./ChartConfig";

const BarChart = ({index, title, dataSource }) => {
  const chartRef = useRef(null);
  const modifiedData = {};

  dataSource.forEach((data) => {
    Object.keys(data).forEach((key) => {
      if(!modifiedData[key]) {
        modifiedData[key] = []
      }
      modifiedData[key].push(data[key])
    })
  })

  if(!modifiedData) return;

  const data = {
    labels: modifiedData.FY,
    datasets: [
      {
        label: "PS",
        data: modifiedData.PS, // Data for PS
        backgroundColor: "rgb(249, 173, 170)", // Red
        borderColor: "rgb(249, 173, 170)",
        // borderWidth: 1,
        // borderRadius: { topLeft: 10, topRight: 10, bottomLeft: 0, bottomRight: 0 },
      },
      {
        label: "MS",
        data: modifiedData.MS, // Data for MS
        backgroundColor: "rgb(164, 182, 218)", // Blue
        borderColor: "rgb(164, 182, 218)",
        // borderWidth: 1,
        borderRadius: { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 },
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      title: {
        display: true,
        text: title,
      },
      datalabels: {
        color: "white",
        font: {
          weight: "bold",
        },
        formatter: (value, context) => {
          if (context.dataset.label === "PS") {
            return `${value}`;
          } else if (context.dataset.label === "MS") {
            return `${value}`;
          }
          return null;
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true, // Stacking enabled
        beginAtZero: true,
      },
    },
  };


  const downloadChart = (format) => {
    if (chartRef.current) {
      const chartInstance = chartRef.current;
      const url = chartInstance.toBase64Image(format); // Convert to Base64
      const link = document.createElement("a");
      link.href = url;
      link.download = `${title.split(' ').join('-')}.${format === "image/png" ? "png" : "jpg"}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };


  return (
    <div style={{ width: "200px", flex: 1, height: "300PX", backgroundColor: "white", borderRadius: "7px" }} >
      {/* <div className="download-graph" onClick={() => downloadChart("image/png")}><DownloadOutlined /></div> */}
      <Bar key={index} ref={chartRef} data={data} options={options} height={300}/>
    </div>
  )
};

export default BarChart;
